export enum AuthenticationType {
  LOGIN_FULFILLED = "entities/USER_AUTHENTICATE_SUCCESS",
  LOGOUT = "entities/USER_UNAUTHENTICATE",
}

export type LoginFulfilledAction = { payload: { idToken: string }; type: AuthenticationType.LOGIN_FULFILLED };

export type LogoutAction = { payload?: { isUserLogout?: boolean }; type: AuthenticationType.LOGOUT };

export type AuthenticationAction = LoginFulfilledAction | LogoutAction;
